"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zoo = exports.ZOO_RULE_PREFIX = void 0;
exports.ZOO_RULE_PREFIX = 'zoo';
var Zoo;
(function (Zoo) {
    Zoo["EditTimezone"] = "zoo:edit-timezone";
    Zoo["EditLocation"] = "zoo:edit-location";
    Zoo["ViewPartnerStatisticsLink"] = "zoo:view-partner-statistics-link";
})(Zoo || (exports.Zoo = Zoo = {}));
